var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9970",
    "data-name": "Group 9970",
    transform: "translate(92 -268)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 20,
    height: 20,
    transform: "translate(-92 268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_283408___email_mail_icon",
    "data-name": "283408_@_email_mail_icon",
    d: "M16.194,4.061a6.413,6.413,0,0,0-2.62-2.609A7.984,7.984,0,0,0,9.705.533,9.162,9.162,0,0,0,5.113,1.665,7.7,7.7,0,0,0,2.028,4.858a9.954,9.954,0,0,0-1.082,4.7,7.646,7.646,0,0,0,2.028,5.659,7.712,7.712,0,0,0,5.7,2.025,10.852,10.852,0,0,0,4.41-.853v-1.35a12.334,12.334,0,0,1-4.41.873A6.273,6.273,0,0,1,3.98,14.247,6.527,6.527,0,0,1,2.352,9.486a8.807,8.807,0,0,1,.88-4.024,6.217,6.217,0,0,1,2.549-2.68,7.874,7.874,0,0,1,3.924-.939,6.562,6.562,0,0,1,3.171.746,5.161,5.161,0,0,1,2.129,2.127,6.649,6.649,0,0,1,.749,3.218,6.066,6.066,0,0,1-.577,2.837,1.705,1.705,0,0,1-1.5,1.091q-1.346,0-1.345-1.807V9.831l.253-4.771a9.893,9.893,0,0,0-1.568-.35,10.944,10.944,0,0,0-1.558-.126A4.066,4.066,0,0,0,6.326,5.877,4.768,4.768,0,0,0,5.133,9.242a4.324,4.324,0,0,0,.855,2.827,2.9,2.9,0,0,0,2.372,1.04,3.17,3.17,0,0,0,1.786-.5,3.212,3.212,0,0,0,1.158-1.38h.081a2.125,2.125,0,0,0,2.175,1.877,2.859,2.859,0,0,0,1.861-.66,4.227,4.227,0,0,0,1.254-1.858,7.516,7.516,0,0,0,.445-2.638A7.952,7.952,0,0,0,16.194,4.061ZM7.4,6.745a2.508,2.508,0,0,1,2.058-.913,5.886,5.886,0,0,1,1.588.2l-.142,2.65q-.182,3.176-2.276,3.177-1.972,0-1.973-2.578A3.916,3.916,0,0,1,7.4,6.745Z",
    transform: "translate(-90.946 269.467)",
    fill: "#929292",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/at.37ba0ac7d98119a1fa267e8ba60122da.svg";
export { ForwardRef as ReactComponent };